module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av526-b2ccaaba15a8aa26f8639dbb3821783c.jpg";